
<template>
  <div class="form-row" v-if="companyInfo">
    <form :class="{ 'loading-opacity': preloader, 'col-sm-12 p-4': isAdmin, 'col-md-12 mb-0': !isAdmin }">
      <div class="form-group">
        <h3 class="text-center mb-0">
          GDPR
        </h3>
      </div>
      <div class="form-group row align-items-center">
        <label class="h4 col-sm-12">Who We Are</label>
        <label class="col-sm-12 mb-sm-0">
          {{ companyInfo.company_name }} is committed to gathering and processing your personal information responsibly and in compliance with relevant data protection regulations and laws. This privacy notice outlines your rights, our obligations, and the reasons for processing your data.
          <br><br>
          <strong>Registered Office:</strong> {{ companyInfo.address }} <br>
          <strong>Company Registration Number:</strong> {{ companyInfo.company_number }} <br>
<!--          <strong>ICO Registration Number:</strong> {{ ICO_Registration_Number_Placeholder }} <br>-->
          <strong>Data Controller:</strong> {{companyInfo.company_name}} <br>
          <strong>Data Protection Officer:</strong> Contact Person, Tel: {{companyInfo.company_phone}}
        </label>
      </div>

      <div class="form-group row align-items-center">
        <label class="h4 col-sm-12">Information We Collect</label>
        <label class="col-sm-12 mb-sm-0">
          To meet legal, statutory, and contractual obligations under BS 7858:2019 and client service requirements, we collect only necessary personal data, including employment history, using online form submissions.
        </label>
      </div>

      <div class="form-group row align-items-center">
        <label class="h4 col-sm-12">How We Use Your Personal Data</label>
        <label class="col-sm-12 mb-sm-0">
          {{ companyInfo.company_name }} processes your data strictly for the purposes outlined below. We will never share, sell, or disclose your data without consent, except where required by law.
          <br>
          <strong>Purpose of Processing:</strong>
          <ul>
            <li>Employment and client security services.</li>
            <li>Business accounting and tax obligations.</li>
            <li>Pre-employment background checks.</li>
            <li>Sharing updates and information for legitimate interests.</li>
          </ul>
          <strong>Retention Period:</strong> Data is retained only as long as necessary.
        </label>
      </div>

      <div class="form-group row align-items-center">
        <label class="h4 col-sm-12">Your Rights</label>
        <label class="col-sm-12 mb-sm-0">
          You have the right to:
          <ul>
            <li>Information about what we hold, purposes, categories, recipients, retention periods, and sources.</li>
            <li>Request corrections promptly unless legally restricted.</li>
            <li>Revoke consent for specific data uses at any time.</li>
          </ul>
        </label>
      </div>

      <div class="form-group row align-items-center">
        <label class="h4 col-sm-12">Sharing Your Data</label>
        <label class="col-sm-12 mb-sm-0">
          We do not share personal information without your consent except in the following cases:
          <ul>
            <li><strong>Third-Party Services:</strong> Vetting and screening in line with BS 7858:2019.</li>
            <li>Sharing SIA license numbers, nationality, and right-to-work status when required.</li>
          </ul>
          All third parties comply with this privacy notice and applicable laws.
        </label>
      </div>

      <div class="form-group row align-items-center">
        <label class="h4 col-sm-12">Data Safeguards</label>
        <label class="col-sm-12 mb-sm-0">
          {{ companyInfo.company_name }} implements robust security measures to protect your personal data, including:
          <ul>
            <li>Restricted access</li>
            <li>IT authentication</li>
            <li>Firewalls and anti-virus protection</li>
          </ul>
        </label>
      </div>

      <div class="form-group row align-items-center">
        <label class="h4 col-sm-12">Data Retention</label>
        <label class="col-sm-12 mb-sm-0">
          We retain personal information only as long as necessary. Basic data (e.g., name, address) is kept for 6 years after employment termination.
        </label>
      </div>

      <div class="form-group row align-items-center">
        <label class="h4 col-sm-12">Special Categories of Data</label>
        <label class="col-sm-12 mb-sm-0">
          We may process sensitive data (e.g., health information) to assess your fitness for tasks. Explicit consent is obtained for processing sensitive data. You may modify or withdraw consent anytime unless legally restricted.
        </label>
      </div>

      <div class="form-group row align-items-center">
        <label class="h4 col-sm-12">Consent</label>
        <label class="col-sm-12 mb-sm-0">
          I consent to {{ companyInfo.company_name }} processing my personal data as detailed in this Privacy Notice.
        </label>
      </div>


      <div class="form-group row align-items-center">
        <label class="col-sm-12 mb-sm-0">
          {{ companyInfo.company_name }} take your privacy seriously and will only process your personal data with your
          consent and in accordance with the terms stated in our Privacy Notice. If you consent to us collecting and
          processing your personal data, please sign below: -

          I consent to {{ companyInfo.company_name }} for processing my personal data as detailed in Privacy Notice:
        </label>
        <app-input class="col-sm-8 mr-sm-2 mb-sm-2"
                   type="single-checkbox"
                   :list-value-field="$t('I Agree')"
                   v-model="gdpr_info.consent"
                   placeholder=""/>

        <div class="col-sm-6">
          <label class="col-sm-12 mb-sm-0">
            Signature:
          </label>
          <div v-if="gdpr_info.signature"  style="border: dashed 0.5px;">
            <img :src="gdpr_info.signature" alt="Signature" width="400px" class="img-fluid">
          </div>
          <div v-if="!gdpr_info.signature">
            <VueSignaturePad ref="signaturePad" width="100%"
                             height="200px"
                             :options="options"
                             style="border: dashed 0.5px;"

            />
            <button @click.prevent="clearSignature" class="btn btn-danger mr-2" >Undo</button>
            <button @click.prevent="saveSignature" class="btn btn-success" >Save</button>

          </div>

        </div>
        <label class="col-sm-12 mb-sm-0">Date</label>
        <app-input class="col-sm-6 mr-sm-2 mb-sm-2"
                   type="date"
                   v-model="gdpr_info.consent_date_time"
                   placeholder=""/>
        <a v-if="isAdmin" href="https://www.protectuk.police.uk/group/84" target="_blank">Click here</a>

      </div>
    </form>
  </div>
</template>

<script>
import {FormMixin} from "@/core/mixins/form/FormMixin";
export default {
  name: "GdprDetail",
  mixins: [FormMixin],
  props: {
    preloader: {
      type: Boolean,
      default: false
    },
    gdpr_info: {
      type: Object,
      default: () => ({})
    },
    isAdmin: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      options: {
        penColor: "#000",
      },
    }
  },
  computed:{
    companyInfo(){
      return this.gdpr_info.companyInfo? this.gdpr_info.companyInfo : this.$store.state.settings.appSettings;
    },

  },
  methods: {
    clearSignature() {
      this.$refs.signaturePad.undoSignature();
      // this.$refs.signaturePad.clear();
    },
    saveSignature() {
      const { isEmpty, data } = this.$refs.signaturePad.saveSignature();

      this.gdpr_info.signature = data;
    }
  },
}
</script>

<style scoped>

</style>